import { memo } from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import ManagePlan from "./ManagePlan";

// -----------------------------------------------------------------------------

const BillingManagePlanPage = memo(
  function BillingManagePlanPage(): JSX.Element {
    return (
      <>
        <Typography variant="h4" fontWeight="bold" sx={HeaderLabelSX}>
          Billing
        </Typography>
        <Box sx={{ mt: 3 }}>
          <ManagePlan />
        </Box>
      </>
    );
  }
);

export default BillingManagePlanPage;

// -----------------------------------------------------------------------------

const HeaderLabelSX = { mt: 1, mr: 1 };
